<template>
  <div class="personel-profile-section">
    <box :title="$t('personal-profile')">
      <div class="px-3 py-1">
        <div v-if="alertBirthdayList.length > 0">
          <div v-for="(birthday, i) in alertBirthdayList" :key="i">
            <v-alert
              class="mt-2"
              text
              dense
              color="teal"
              icon="mdi-cake-layered"
              border="left"
              v-if="birthday"
              dismissible
            >
              <span v-html="birthday"></span>
            </v-alert>
          </div>
        </div>
        <div class="ma-0 pa-0 mt-2">
          <v-row>
            <v-col cols="9">
              <v-row class="personel-info">
                <v-col cols="12">
                  <span>{{ $t("person-name") }} : </span
                  ><span class="value">{{ personel.PersonName }}</span>
                </v-col>
                <v-col cols="6">
                  <span>{{ $t("card-no") }} : </span
                  ><span class="value">{{ personel.Perno }}</span>
                </v-col>
                <v-col cols="6">
                  <span>{{ $t("birthdate") }} : </span
                  ><span class="value">{{ personel.BirthDate }}</span>
                </v-col>
                <v-col cols="6">
                  <span>{{ $t("shenas-no") }} : </span
                  ><span class="value">{{ personel.ShenasNo }}</span>
                </v-col>
                <v-col cols="6">
                  <span>{{ $t("meli-code-no") }} : </span
                  ><span class="value">{{ personel.MeliCodeNo }}</span>
                </v-col>
                <v-col cols="6">
                  <span>{{ $t("birth-city") }} : </span
                  ><span class="value">{{ personel.BirthCity }}</span>
                </v-col>
                <v-col cols="6">
                  <span>{{ $t("father-name") }} : </span
                  ><span class="value">{{ personel.FatherName }}</span>
                </v-col>
                <v-col cols="6">
                  <span>{{ $t("marital-status") }} : </span
                  ><span
                    class="value"
                    v-text="getMarried(personel.IsMarried)"
                  ></span>
                </v-col>
              </v-row>
              <v-row class="mt-2">
                <v-col cols="6">
                  <span>{{ $t("work-group") }} : </span
                  ><span class="value">{{ personel.WorkGroup }}</span>
                </v-col>
                <v-col cols="6">
                  <span>{{ $t("section-name") }} : </span
                  ><span class="value">{{ personel.SectionName }}</span>
                </v-col>
              </v-row>
            </v-col>
            <v-col cols="3" lg="2" style="max-width: 200px; min-width: 50px">
              <v-img
                :src="`data:image/png;base64,${personel.PersonImage}`"
                contain
                class="grey darken-4"
              ></v-img>
            </v-col>
          </v-row>
        </div>
      </div>
    </box>
  </div>
</template>

<script>
//import moment from "jalali-moment";
import ResultType from "../../model/ResultType";
export default {
  props: { args: Object },
  data() {
    return {
      personel: {},
      alertBirthdayList: [],
    };
  },
  mounted() {
    this.getArgs();
  },
  created() {
    // this.getArgs();
  },
  updated(){
    this.getArgs();
    debugger

  },
  watch: {
    args() {
      this.getArgs();
    },
  },
  computed: {},
  methods: {
    getArgs() {
      debugger
      ////console.log(this.args);
      // var activeUser=localStorage.getItem("userActive")
      if ((this.args && this.args.pid)) {
        //
        debugger
        var perno = this.args.pid;
        this.$store.dispatch("getPersonDetail", { perno }).then((result) => {
          ////console.log(result);
          if (result.type === ResultType.success) {
            this.personel = result.data;
          }
        });
      } else {
        this.getProfile();
      }
    },
    getProfile() {
      //this.personel = this.$store.state.personel.personelDetail;
      this.personel = this.$store.getters.getPersonelDetail;

      this.checkShowBirthday();
    },
    checkShowBirthday() {
      this.$store.dispatch("GetAlertBirthDay").then((result) => {
        if (result.type === ResultType.success) {
          if (result.data) {
            if (result.data.includes("<br />")) {
              this.alertBirthdayList = result.data.split("<br />");
            } else {
              this.alertBirthdayList.push(result.data);
            }
          }
        }
      });
      /*this.$store.dispatch("readwebkartsetting").then((result) => {
        if (result.type === ResultType.success) {
          if (result.data.ShowBirthDay == "1") {
            if (this.personel.BirthDate) {
              var BirthDate = moment(this.personel.BirthDate, "jYYYY/jMM/jDD")
                .locale("fa")
                .format("MM/DD");
              var now = moment().locale("fa").format("MM/DD");
              if (BirthDate == now) {
                this.isShowBirthday = true;
              }
            }
          }
        }
      });*/
    },
    getMarried(isMarried) {
      if (isMarried == 2) {
        return this.$t("Married");
      }
      if (isMarried == 1) {
        return this.$t("Single");
      }
    },
  },
};
</script>

<style>
.personel-info .col {
  padding: 5px 0px !important;
}
</style>